module.exports = __webpack_public_path__ + "images/bg-orde-list-1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bg-orde-list-1.png
// module id = 828
// module chunks = 130